<template>
  <el-dialog title="轨迹回放" width="1200px" :visible="showDialog" :close-on-click-modal="false" @close="onClose">
    <el-card class="detailPlayback">
      <el-form ref="searchInfo" :model="info" class="global-form" :inline="true">
        <el-select v-if="worker.teamName" v-model="info.deviceNumber" placeholder="请选择人员">
          <template v-for="(item, index) in workerList">
            <el-option :label="item.name" :value="item.deviceNumber" :key="index"></el-option>
          </template>
        </el-select>
        <el-select v-else v-model="info.objectId" placeholder="请选择人员">
          <template v-for="(item, index) in workerList">
            <el-option :label="item.workerName" :value="item.workerId" :key="index"></el-option>
          </template>
        </el-select>
        <el-form-item>
          <el-date-picker v-model="date" popper-class="global-datetime-hourOnly" type="datetimerange"
            format="yyyy-MM-dd HH" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions"
            start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="vessel">
        <div class="slider">
          <el-slider v-model="sliderVal" vertical :show-tooltip="false">
          </el-slider>
        </div>
        <div v-if='!start || pause' class="operation" @click='onStart'>
          <img src="@/assets/img/location/start.svg" alt="">
        </div>
        <div v-else class="operation" @click='pauseMove'>
          <img src="@/assets/img/location/pause.svg" alt="">
        </div>
        <div v-if="start" class="operation playEnd" @click='endMove'>
          <img src="@/assets/img/location/stop.svg" alt="">
        </div>
        <div v-if="!start" class="operation playSpeed" @click="speedUp">
          <img v-if="playSpeedTimes == 1" src="@/assets/img/location/1.svg" alt="">
          <img v-if="playSpeedTimes == 2" src="@/assets/img/location/2.svg" alt="">
          <img v-if="playSpeedTimes == 4" src="@/assets/img/location/4.svg" alt="">
          <img v-if="playSpeedTimes == 8" src="@/assets/img/location/8.svg" alt="">
        </div>
        <div id="map1"></div>
      </div>
    </el-card>
  </el-dialog>
</template>

<script>
import { drawPolygon } from '@/utils/formatData'
import { timeFormat } from '@/utils/formatData'

export default {
  name: 'OnPlay',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    worker: {
      type: Object
    }
  },
  data() {
    return {
      date: '',
      info: {
        objectId: '',
        deviceNumber: '',
        startTime: '',
        endTime: ''
      },
      historyList: [],
      lngLatList: [],
      workerList: [],
      markerDotList: [],
      projectLocationList: [],
      map: null,
      marker: null,
      playSpeed: 3000,
      playSpeedTimes: 1,
      sliderVal: 0,
      start: false,
      pause: false,
      projectInfo: {
        longitude: '',
        latitude: ''
      },
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick: (picker) => {
            const start = this.getCurrentTimeToHour()
            start.setHours(0)
            picker.$emit('pick', [start, this.getCurrentTimeToHour()])
          }
        }, {
          text: '昨天',
          onClick: (picker) => {
            const end = new Date(new Date().toLocaleDateString())
            const start = new Date()
            start.setTime(end.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '前天',
          onClick(picker) {
            const end = new Date(new Date().toLocaleDateString())
            const start = new Date()
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            start.setTime(end.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '本周',
          onClick: (picker) => {
            const end = this.getCurrentTimeToHour()
            const start = new Date(new Date().toLocaleDateString())
            let day = start.getDay()
            day = day === 0 ? 6 : day - 1
            start.setTime(start.getTime() - 3600 * 1000 * 24 * day)
            picker.$emit('pick', [start, end])
          }
        }],
        onPick: (date) => {
          this.date = date.minDate.getTime()
          if (date.maxDate) {
            this.date = ''
          }
        }
      },
      disabledDate: (time) => {
        if (this.date !== '') {
          const one = 30 * 24 * 3600 * 1000
          const minTime = this.date - one
          const maxTime = this.date + one
          return time.getTime() > (Date.now() - 8.64e6) || (time.getTime() < minTime || time.getTime() > maxTime)
        } else {
          return time.getTime() > (Date.now())
        }
      }
    }
  },
  computed: {
    projectId() {
      return this.$store.state.projectId
    }
  },
  watch: {
    showDialog(val) {
      if (val) {
        this.$nextTick(() => {
          this.info.objectId = this.worker.objectId
          this.info.deviceNumber = this.worker.deviceNumber
          this.defaultDate()
          this.worker.teamName ? this.getTeamList() : this.getDeviceList()
        })
      }
    }
  },
  created() {
  },
  // 监听页面离开
  destroyed() {
    if (this.map) {
      // 停止运动
      this.marker && this.marker.stopMove()
      this.map.off('click', () => {
        //
      })
      this.map.destroy()
    }
  },
  methods: {
    getCurrentTimeToHour(t) {
      const date = new Date()
      if (t === 'end') {
        date.setMinutes(59)
        date.setSeconds(59)
      } else if (t === 'start') {
        date.setMinutes(0)
        date.setSeconds(0)
      }
      return date
    },
    defaultDate() {
      // 默认最近一天
      const end = this.getCurrentTimeToHour('end')
      const start = this.getCurrentTimeToHour('start') - 3600 * 1000 * 24
      this.date = [timeFormat(start), timeFormat(end.getTime())]
      this.getData()
    },
    // 查询轨迹数据
    getData() {
      const info = this.date ? {
        objectId: this.info.objectId,
        deviceNumber: this.info.teamName ? this.info.deviceNumber : '',
        startTime: this.date[0],
        endTime: this.date[1]
      } : this.info
      this.$axios.get(this.$apis.laborManage.selectYhTrajectory, info).then(res => {
        this.historyList = res || []
        this.lngLatList = []
        // 将轨迹需要经纬度push到数组
        res.map((item) => {
          this.lngLatList.push([Number(item.longitude), Number(item.latitude)])
        })
        if (res.length === 0) {
          this.$message({
            message: '未查询到数据',
            type: 'warning'
          })
        }
        this.getProjectLocation()
      })
    },
    getProjectLocation() {
      this.$axios.get(this.$apis.project.selectYhProjectMapByProjectId, {
        projectId: this.projectId
      }).then((res) => {
        this.$nextTick(() => {
          this.projectInfo = res
          this.loadMap()
        })
      })
    },
    // 获取工人列表
    getDeviceList() {
      this.$axios.get(this.$apis.worker.selectYhWorkerList, {
        projectId: this.projectId
      }).then((res) => {
        this.workerList = res || []
      })
    },
    // 获取班组列表
    getTeamList() {
      this.$axios.get(this.$apis.laborManage.selectYhTeamByTeamId, {
        teamId: this.info.objectId
      }).then((res) => {
        this.workerList = res.deviceList || []
        this.workerList.forEach((item) => {
          item.name = (res.teamName.length > 6 ? res.teamName.substring(0, 6) + '...' : res.teamName) + '【' + item.deviceNumber.substring(item.deviceNumber.length - 3, item.deviceNumber.length) + '】'
        })
      })
    },
    // 渲染地图
    loadMap() {
      AMap.plugin(['AMap.MoveAnimation'], () => {
        const center = [Number(this.projectInfo.longitude), Number(this.projectInfo.latitude)]
        this.$nextTick(() => {
          const map = new AMap.Map('map1', {
            center: center,
            zoom: 11
          })
          this.map = map
          // 画电子围栏
          drawPolygon(this.map, this.projectInfo.locationList, null)
          if (this.lngLatList.length > 0) {
            this.marker = new AMap.Marker({
              map: this.map,
              position: this.lngLatList[0],
              icon: new AMap.Icon({
                // 图标尺寸
                size: new AMap.Size(36, 48),
                // 图标的取图地址
                image: require('@/assets/icon/bracelet/online.svg'),
                imageSize: new AMap.Size(36, 48)
              }),
              zIndex: 10000,
              offset: new AMap.Pixel(-20, -45)
            })
            const markerDot = new AMap.Marker({
              map: this.map,
              position: this.lngLatList[0],
              zIndex: 1,
              icon: new AMap.Icon({
                // 图标尺寸
                size: new AMap.Size(12, 12),
                // 图标的取图地址
                image: require('@/assets/icon/location/dot.svg'),
                imageSize: new AMap.Size(12, 12)
              }),
              offset: new AMap.Pixel(-8, -7),
              label: {
                offset: new AMap.Pixel(0, -20), // 设置文本标注偏移量
                content: '', // 设置文本标注内容
                direction: 'top' // 设置文本标注方位
              }
            })
            this.markerDotOpen(markerDot, 0)
            this.map.add(markerDot)
            this.map.setFitView([this.marker])
          }
        })
      })
    },
    // 加速
    speedUp() {
      if (this.playSpeedTimes < 8) {
        this.playSpeedTimes = this.playSpeedTimes * 2
      } else {
        this.playSpeedTimes = 1
      }
    },
    // 渲染动效
    loadMarker() {
      this.sliderVal = 0
      this.marker.moveAlong(this.lngLatList, {
        // 每一段的时长
        duration: (this.playSpeed / this.playSpeedTimes).toFixed(2),
        // JSAPI2.0 是否延道路自动设置角度在 moveAlong 里设置
        autoRotation: false
      }, (k) => {
        console.log(k, 111)
        return k
      }, false)
      // 创建跟速度信息展示框
      const carWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, -50),
        content: `<p class='date'>${this.historyList[0].collectTime}</p>`
      })
      // 动态改变信息窗
      const setVehicleSpeedInWidowns = (index) => {
        carWindow.setContent(`
          <p class='date'>${this.historyList[index].collectTime}</p>
        `)
      }
      // 6.速度框随车辆移动
      let schedule = 0
      // 绘制轨迹
      const polyline = new AMap.Polyline({
        map: this.map,
        showDir: true,
        strokeColor: '#3592FE', // 线颜色
        strokeWeight: 2 // 线宽
      })
      // 监听marker移动，改变时间条
      let lnglatBefore = [0, 0]
      this.marker.on('moving', (e) => {
        polyline.setPath(e.passedPath)
        const lastLocation = e.passedPath[e.passedPath.length - 1]
        carWindow.setPosition(lastLocation)
        const number = 100 / (this.historyList.length - 1)
        const lnglatDot = [e.pos.lng, e.pos.lat]
        if (e.progress >= 0.1) {
          this.map.setCenter(lnglatDot)
        }
        if (e.progress === 1) {
          schedule += number
          if (lnglatBefore[0] !== lnglatDot[0] && lnglatBefore[1] !== lnglatDot[1]) {
            const markerDot = new AMap.Marker({
              map: this.map,
              position: lnglatDot,
              zIndex: 1,
              icon: new AMap.Icon({
                // 图标尺寸
                size: new AMap.Size(12, 12),
                // 图标的取图地址
                image: require('@/assets/icon/location/dot.svg'),
                imageSize: new AMap.Size(12, 12)
              }),
              offset: new AMap.Pixel(-8, -7),
              label: {
                offset: new AMap.Pixel(0, -20), // 设置文本标注偏移量
                content: '', // 设置文本标注内容
                direction: 'top' // 设置文本标注方位
              }
            })
            this.markerDotOpen(markerDot, e.index + 1)
            this.map.add(markerDot)
            // 将打过的圆点放进数组方便删除
            this.markerDotList.push(markerDot)
            lnglatBefore = lnglatDot
          }
        } else if (e.progress) {
          this.sliderVal = number * e.progress + schedule
        }
        if (e.index === this.historyList.length - 2 && e.progress === 1) {
          this.sliderVal = 100
          this.endMove()
        }
        setVehicleSpeedInWidowns(e.index)
      })
      this.map.setFitView([polyline])
      // 7.打开速度框
      carWindow.open(this.map, this.marker.getPosition())
    },
    // 添加圆点点击弹出信息窗
    markerDotOpen(markerDot, index) {
      markerDot.on('click', (e) => {
        let labelShow = true
        this.map.getAllOverlays('marker').map((item) => {
          // 关闭所有信息窗
          if (item.getLabel().content !== '') {
            item.setLabel({
              content: ''
            })
            // 当点击同一个点时不添加信息窗
            if (item.hS === e.target.hS) {
              labelShow = false
            }
          }
        })
        // 添加信息窗
        if (labelShow) {
          markerDot.setLabel({
            content: `<p class='date'>${this.historyList[index].collectTime}</p><div class='amap-info-sharp'></div>`
          })
          markerDot.setzIndex(this.markerDotList.length + 1)
        }
      })
    },
    // 开始
    onStart() {
      if (this.pause) {
        this.pause = false
        this.marker.resumeMove()
      } else {
        this.start = true
        if (this.markerDotList.length > 0) {
          this.map.remove(this.markerDotList)
        }
        this.loadMarker()
      }
    },
    // 暂停
    pauseMove() {
      this.pause = true
      this.marker.pauseMove()
    },
    // 停止运动
    endMove() {
      this.start = false
      this.pause = false
      this.marker.stopMove()
    },
    // 查询
    onSearch() {
      this.start = true
      this.sliderVal = 0
      if (this.marker) {
        this.endMove()
        this.map.remove(this.marker)
      }
      this.getData()
    },
    onClose() {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog__body {
  height: 700px;
}

.detailPlayback {
  width: 100%;
  height: 100%;

  .vessel {
    width: 100%;
    height: 100%;
    position: relative;
  }

  ::v-deep .el-card__body {
    width: 100%;
    height: 100%;
  }

  #map1 {
    width: 100%;
    height: calc(100% - 50px);
  }

  ::v-deep .amap-info-outer {
    .text {
      font-size: 14px;
      color: #000;
      text-align: center;
    }

    .speed {
      font-size: 20px;
      font-weight: bold;
      color: #3592FE;
    }

    .date {
      font-size: 14px;
      color: #999999 !important;
      line-height: 30px;
    }

    .amap-info-close {
      display: none;
    }
  }

  ::v-deep .amap-marker-label {
    .amap-info-sharp {
      position: absolute;
      margin-left: -8px;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      bottom: -8px;
      left: 50%;
      border-top: 8px solid #fff;
    }

    .amap-info-sharp:after {
      position: absolute;
      content: "";
      margin-top: -6px;
      border-top: 8px solid rgba(0, 0, 0, .3);
      margin-left: -8px;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      filter: blur(2px);
      z-index: -1;
    }

    border: none !important;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    padding: 12px 18px;

    .date {
      font-size: 14px;
      color: #999999 !important;
      line-height: 30px;
    }
  }

  .slider {
    position: absolute;
    top: 20%;
    left: 50px;
    z-index: 20;
    height: 60%;
    width: 32px;
    padding: 4px;
    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    transform: rotate(180deg);

    ::v-deep .el-slider {
      height: 100%;
      width: 100%;
      border-radius: 16px;

      .el-slider__runway {
        border-radius: 16px;
        width: 24px;
        margin: 0;
        overflow: hidden;

        .el-slider__bar {
          width: 24px;
          background: linear-gradient(180deg, #6FB2FE 0%, #1B85FF 100%);
        }

        .el-slider__button-wrapper {
          display: none;
        }
      }
    }
  }

  .operation {
    width: 80px;
    height: 50px;
    background: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 10px 0px;
    border-radius: 25px;
    position: absolute;
    top: 20px;
    left: 24px;
    z-index: 20;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .playSpeed,
  .playEnd {
    left: 140px;
  }

}
</style>
